import { useEffect, useState } from 'react';

function reloadWindowOnHistoryNavigation() {
  const historyTraversal = typeof window !== 'undefined'
      && typeof window.performance !== 'undefined'
      && window.performance.navigation.type === 2;

  if (historyTraversal) {
    window.location.reload();
    return true;
  }

  return false;
}

function usePageReloadOnHistoryNavigation() {
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const wasReload = reloadWindowOnHistoryNavigation();

    const handlePageShow = (event) => {
      if (event.persisted && !wasReload) {
        setPageLoading(true);
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  return [pageLoading];
}

export default usePageReloadOnHistoryNavigation;
